/* Vanshitaaz sale collection — quick add to cart from the card.
   Pick an in-stock size, then Add to cart -> reuses the theme's global
   addToCartQuick() (adds, refreshes cart sections, opens the cart drawer).
   Event-delegated so it keeps working after filter/pagination re-renders. */
(function () {
  'use strict';

  // Resolve the matching variant once every option is chosen (multi-option cards)
  function resolveVariant(card) {
    var sets = card.querySelectorAll('[data-vzsale-opts] .vzsale-card__optset');
    var chosen = [];
    var complete = true;
    sets.forEach(function (set) {
      var sel = set.querySelector('[data-vzsale-opt].is-sel');
      if (sel) { chosen.push(sel.getAttribute('data-value')); } else { complete = false; }
    });
    var add = card.querySelector('[data-vzsale-add]');
    var hint = card.querySelector('[data-vzsale-hint]');
    if (hint) { hint.textContent = ''; hint.classList.remove('is-error'); }

    if (!complete) {
      card.dataset.selectedVariant = '';
      if (add) { add.disabled = true; add.textContent = 'Select options'; }
      return;
    }
    var data = [];
    var script = card.querySelector('[data-vzsale-variants]');
    try { data = JSON.parse(script.textContent); } catch (err) { data = []; }
    var match = data.filter(function (v) {
      return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
    })[0];

    if (match && match.available) {
      card.dataset.selectedVariant = String(match.id);
      if (add) { add.disabled = false; add.textContent = 'Add to cart'; }
    } else {
      card.dataset.selectedVariant = '';
      if (add) { add.disabled = true; add.textContent = 'Sold out'; }
      if (hint) { hint.textContent = 'This combination is sold out'; hint.classList.add('is-error'); }
    }
  }

  document.addEventListener('click', function (e) {
    // 0) reveal the size/options panel (keeps the grid compact)
    var trigger = e.target.closest('[data-vzsale-trigger]');
    if (trigger) {
      var tcard = trigger.closest('[data-vzsale-card]');
      if (tcard) {
        var panel = tcard.querySelector('[data-vzsale-panel]');
        if (panel) { panel.hidden = false; }
        trigger.style.display = 'none';
      }
      return;
    }

    // 1) size selection
    var sizeBtn = e.target.closest('[data-vzsale-size]');
    if (sizeBtn) {
      var card = sizeBtn.closest('[data-vzsale-card]');
      if (!card) return;
      card.querySelectorAll('[data-vzsale-size]').forEach(function (b) { b.classList.remove('is-sel'); });
      sizeBtn.classList.add('is-sel');
      card.dataset.selectedVariant = sizeBtn.getAttribute('data-variant-id') || '';
      card.dataset.selectedLabel = sizeBtn.getAttribute('data-label') || '';
      var add = card.querySelector('[data-vzsale-add]');
      if (add) { add.disabled = false; add.textContent = 'Add to cart'; }
      var hint = card.querySelector('[data-vzsale-hint]');
      if (hint) { hint.textContent = ''; hint.classList.remove('is-error'); }
      return;
    }

    // 1b) multi-option value selection (e.g. Top size + Bottom size)
    var optBtn = e.target.closest('[data-vzsale-opt]');
    if (optBtn) {
      var ocard = optBtn.closest('[data-vzsale-card]');
      if (!ocard) return;
      var idx = optBtn.getAttribute('data-opt-index');
      ocard.querySelectorAll('[data-vzsale-opt][data-opt-index="' + idx + '"]').forEach(function (b) { b.classList.remove('is-sel'); });
      optBtn.classList.add('is-sel');
      // once the first option is chosen, reveal the remaining option(s) immediately
      if (idx === '0') {
        ocard.querySelectorAll('.vzsale-card__optset--hidden').forEach(function (s) { s.classList.remove('vzsale-card__optset--hidden'); });
      }
      resolveVariant(ocard);
      return;
    }

    // 2) add to cart
    var addBtn = e.target.closest('[data-vzsale-add]');
    if (!addBtn || addBtn.disabled) return;

    var card2 = addBtn.closest('[data-vzsale-card]');
    var hint2 = card2 ? card2.querySelector('[data-vzsale-hint]') : null;
    var variantId = addBtn.getAttribute('data-variant-id') || (card2 && card2.dataset.selectedVariant);

    if (!variantId) {
      if (hint2) { hint2.textContent = 'Please select a size'; hint2.classList.add('is-error'); }
      return;
    }

    addBtn.classList.add('is-loading');
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';
    if (hint2) { hint2.textContent = ''; hint2.classList.remove('is-error'); }

    var reset = function () {
      addBtn.classList.remove('is-loading');
      addBtn.disabled = false;
      addBtn.textContent = 'Add to cart';
    };

    if (typeof window.addToCartQuick === 'function') {
      try { window.addToCartQuick(variantId, 1); } catch (err) { /* no-op */ }
      // addToCartQuick handles the drawer; give the button a moment then reset
      setTimeout(reset, 1300);
    } else {
      // Fallback: add via AJAX then reload so the cart reflects it
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status) { throw new Error(data.description || 'Could not add'); }
          window.location.reload();
        })
        .catch(function () {
          reset();
          if (hint2) { hint2.textContent = 'Could not add — please try again.'; hint2.classList.add('is-error'); }
        });
    }
  });

  // "Hide sold out" toggle -> show/hide sold-out grid cells
  document.addEventListener('change', function (e) {
    var t = e.target.closest('[data-vzsale-hide-soldout]');
    if (!t) return;
    var grid = document.getElementById('product-grid');
    if (grid) { grid.classList.toggle('vzsale-soldout-hidden', t.checked); }
  });
})();
